import React, { memo, useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, FormField, withLabelAndError } from '@honda-canada/design-system-react';
import debounce from 'lodash.debounce';
import formatPrice from '@honda-canada/js-utilities/lib/formatPrice';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
// import formatAndValidateCurrencyInput from '../../utils/formatAndValidateDownPaymentInput';
import { useFinance } from '../SelectProductsContext/SelectProductsProvider';
import { DEBOUNCE_WAIT_TIME } from '../../utils/constants';
import { usePriceAndFinanceDetails } from '../PriceAndFinanceContext';

const FormFieldWithLabelAndError = withLabelAndError(FormField);

function formatDownPaymentInput(downPayment, language, decimalPlaces) {
  return downPayment > 0 ? formatPrice(downPayment, language, decimalPlaces) : 0;
}

const DownPaymentInput = ({ isSummary }) => {
  // eslint-disable-next-line no-unused-vars
  const [, setFinance] = useFinance();
  const { finance: financeDetails } = usePriceAndFinanceDetails();
  const { sitecoreContext } = useSitecoreContext() || {};
  const language = sitecoreContext?.language || 'en';
  const downPayment = formatDownPaymentInput(financeDetails?.monthly?.downPayment, language, 2);
  const [input, setInput] = useState(downPayment);

  useEffect(() => {
    // Update downpayment with the fetched maximum value
    setFinance({ downPayment: financeDetails?.monthly?.downPayment || 0 });
  }, []);

  const handleValidationAndFinance = useCallback(
    debounce(value => {
      const numericValue = parseFloat(value.replace(',', '.')) || 0;
      setFinance({ downPayment: numericValue });
    }, DEBOUNCE_WAIT_TIME),
    [],
  );

  const onChange = ({ target: { value } }) => {
    const regexp = language === 'en' ? /^[0-9]*(\.[0-9]{0,2})?$/ : /^[0-9]*(,[0-9]{0,2})?$/;
    const formattedRegExp = language === 'en' ? value.replace(/[$,]/g, '') : value.replace(/[$ ]/g, '');
    if (!regexp.test(formattedRegExp)) return;

    setInput(formattedRegExp);
    handleValidationAndFinance(formattedRegExp);
  };

  return (
    <Box data-testid="cy-formfield">
      <FormFieldWithLabelAndError
        width={isSummary ? '170px' : ['100%', '100%', '390px']}
        clearIconAriaLabel="Clear input"
        styling="secondary"
        input={{
          name: 'downPayment',
          value: input,
          placeholder: formatPrice(input, language, 0),
          onChange,
          ariaLabel: 'enter down payment',
          handleInputReset: () => {
            setInput('');
            setFinance({ downPayment: 0 });
          },
        }}
      />
    </Box>
  );
};

DownPaymentInput.propTypes = {
  isSummary: PropTypes.bool,
};

export default memo(DownPaymentInput);
